/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.repo.listMissingBlobs'

export { $nsid }

/** Returns a list of missing blobs for the requesting account. Intended to be used in the account migration flow. */
const main = l.query(
  $nsid,
  l.params({
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 1000 }), 500),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    blobs: l.array(l.ref<RecordBlob>((() => recordBlob) as any)),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

type RecordBlob = {
  $type?: 'com.atproto.repo.listMissingBlobs#recordBlob'
  cid: l.CidString
  recordUri: l.AtUriString
}

export type { RecordBlob }

const recordBlob = l.typedObject<RecordBlob>(
  $nsid,
  'recordBlob',
  l.object({
    cid: l.string({ format: 'cid' }),
    recordUri: l.string({ format: 'at-uri' }),
  }),
)

export { recordBlob }
